import "perfect-scrollbar/css/perfect-scrollbar.css";